import { render, staticRenderFns } from "./r-item-addon-kind.vue?vue&type=template&id=0eb1af72"
import script from "./r-item-addon-kind.vue?vue&type=script&lang=js"
export * from "./r-item-addon-kind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eb1af72')) {
      api.createRecord('0eb1af72', component.options)
    } else {
      api.reload('0eb1af72', component.options)
    }
    module.hot.accept("./r-item-addon-kind.vue?vue&type=template&id=0eb1af72", function () {
      api.rerender('0eb1af72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-addon/r-item-addon-kind.vue"
export default component.exports